import React from "react";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDispatch, useSelector } from "react-redux";
import {
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";
import MonthPicker from "../../../../components/reactMonthPicker/reactMonthPicker";

const DatePicker = ({ moduleName, monthly, updateFilters }) => {
  const dispatch = useDispatch();

  const {
    filters: { endDate, startDate, rangeOptions },
    calendarStartDate,
    calendarEndDate
  } = useSelector((state) => state[moduleName]);

  let commonProps = {
    startDate,
    endDate,
    calendarEndDate,
    updateDates: (newStartDate, newEndDate) => {
      // build new custom range

      const selectedRangeOption = getSelectedRangeOptionWithCustom({
        payload: {
          startDate: newStartDate,
          endDate: newEndDate
        }
      });
      // create new range options in order to reflect new custom range in the range options list
      const newRangeOptions = getRangeOptionsWithCustom(rangeOptions, {
        payload: {
          startDate: newStartDate,
          endDate: newEndDate
        }
      });

      // update start, end dates, along with new range value and range options
      dispatch(
        updateFilters({
          moduleName,
          startDate: newStartDate,
          endDate: newEndDate,
          rangeValue: selectedRangeOption,
          rangeOptions: newRangeOptions
        })
      );
    }
  };

  return (
    <div className="date-select-box select-box-no-width multi">
      <p>Date</p>
      {monthly ? (
        <MonthPicker {...commonProps} calendarStartDate={calendarStartDate} />
      ) : (
        <ReactDatePicker
          {...commonProps}
          isRangePicker
          showDefaultInputIcon={false}
          minDate={calendarStartDate}
        />
      )}
    </div>
  );
};

export default DatePicker;
